<template lang="pug">
  .header
    .container
      .header__wrapper
        a(href="https://www.sap.com/japan/index.html" target="_blank")
          img.header__siteId(
            src="../assets/image/logo_sap.svg"
            alt="sap"
          )
        paramlink.header__siteName(
          title="SAP CX DAY 2022"
          url="/SAPCXDAY/")
        .header__toggle(v-on:click.prevent="toggle")
          span MENU
        nav.header__nav
          .nav
            ul.nav__main
              li
                a(href="#program" v-smooth-scroll="{ duration: 300, offset: -120 }") プログラム
              li
                a(href="#detail" v-smooth-scroll="{ duration: 300, offset: -120 }") 開催概要

</template>

<script>
import Register from "@/components/Register.vue";
import Paramlink from "@/components/Paramlink.vue";

export default {
  components: {
    Register,
    Paramlink
  },
  methods: {
    toggle: function() {
      document.querySelector(".header").classList.toggle('-open');
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/_header.scss";
</style>